import { FC } from 'react';
import { startCase } from 'lodash';
import Autocomplete from 'components/FormElements/AppAutocomplete';
import TextField from 'components/FormElements/AppTextInput';
import { CollectionHistoryEventType } from 'further-types/collection-history';
import PageFilters, { Filter } from 'components/PageFilters';

type Filters = {
  collection?: string;
  eventType?: CollectionHistoryEventType;
  docId?: string;
};

type Props = {
  filters: Filters;
  handleChangeFilters: (filters: Filters) => void;
  collectionNames: Array<string>;
  eventTypeToLabelMap: Record<CollectionHistoryEventType, string>;
};

const ChangeLogFilters: FC<Props> = ({
  filters,
  handleChangeFilters,
  collectionNames,
  eventTypeToLabelMap,
}) => (
  <PageFilters pageId="change-log">
    <Filter>
      <Autocomplete
        disableClearable={true}
        options={collectionNames}
        getOptionLabel={(option) => startCase(option)}
        getOptionKey={(option) => option}
        filterSelectedOptions
        value={filters.collection}
        //@ts-expect-error
        onChange={(_event, collection) => handleChangeFilters({ collection })}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select a data type"
          />
        )}
      />
    </Filter>
    <Filter>
      <TextField
        variant="outlined"
        placeholder="Search by ID"
        onChange={(e) => handleChangeFilters({ docId: e.target.value })}
        value={filters.docId}
      />
    </Filter>
    <Filter>
      <Autocomplete
        options={Object.values(CollectionHistoryEventType)}
        getOptionLabel={(option: CollectionHistoryEventType) =>
          eventTypeToLabelMap[option]
        }
        getOptionKey={(option) => option}
        filterSelectedOptions
        value={filters.eventType}
        //@ts-expect-error
        onChange={(_event, eventType: CollectionHistoryEventType) =>
          handleChangeFilters({ eventType })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select an event type"
          />
        )}
      />
    </Filter>
  </PageFilters>
);

export default ChangeLogFilters;
